import React, {Component} from 'react';
import {
    Route,
    NavLink,
    Link
} from "react-router-dom";
import Paper from '@material-ui/core/Paper'
import Dropzone from 'react-dropzone'
import {storage, database} from '../firebaseconfig.js'

export default class Share extends React.Component {


    render() {
        console.log(this.props)
        return (
            <div className="container">
                <Route path="/students/share/:shareID" render={(props) => <ShareApp {...props} userInfo={this.props.userInfo}/>}/>
            </div>
        )
    }
}

class ShareApp extends React.Component {
    state = {
        draggedOver: false,
        uploading: false,
        allData: []
    }

    componentDidMount() {
        this.getAllFiles()
    }

    getAllFiles = () => {
        const shareID = this.props.match.params.shareID
        database.collection(shareID).get()
            .then(snapshot => {
                const data = snapshot.docs.map((doc) => {
                    return doc.data()
                });
                this.setState({allData: data})
            })
    }

    uploadFile = (files) => {
        this.setState({draggedOver: false})
        this.setState({uploading: true})
        const shareID = this.props.match.params.shareID
        const uid = this.props.userInfo.uid
        const uemail = this.props.userInfo.email
        let file = files[0]
        storage.ref(`/share/${shareID}/${uid}/${file.name}`).put(file)
            .then(result => {
                result.ref.getDownloadURL()
                    .then(url => {
                    const record = {
                        name: result.ref.name,
                        uid: uid,
                        email: uemail,
                        path: url
                    }
                    database.collection(`${shareID}`).add(record)
                    })
                    .then(() => {
                        this.setState({uploading: false})
                        this.setState({draggedOver: false})
                        this.getAllFiles()
                    })
            })

    }

    dragOver = () => {
        this.setState({draggedOver: true})
    }

    onCancel = (e) => {

    }

    render() {
        console.log(this.props)
        const {draggedOver, uploading, allData} = this.state
        console.log(allData)
        return (
            <div>
                <h2>Notebook sharing</h2>
                <Dropzone
                    onDrop={(files) => this.uploadFile(files)}
                    onFileDialogCancel={(e) => this.onCancel(e)}
                    onDragOver={() => this.dragOver()}
                    onDragLeave={() => this.setState({draggedOver: false})}
                    className={'col-12'}
                    style={this.state.draggedOver ? {border: '2px dotted green', borderRadius: '10px'} : {border: "2px dotted black", borderRadius: '10px'}}
                >
                            {this.state.draggedOver
                                ?
                                <div className='align-items-center' style={{padding: '30px 0', color: 'green'}}>Drop it here</div>
                                :
                                <div>
                                {uploading
                                    ? <div className='align-items-center' style={{padding: '30px 0'}}>Uploading...</div>
                                        :
                                <div className='align-items-center' style={{padding: '30px 0'}}>+ Click here or drag .iypnb
                                files here</div>
                                }
                                </div>
                            }
                </Dropzone>
                <div className="row">
                {allData.map(each =>
                    <div className='col-6 col-sm-6 col-md-4 col-lg-3' style={{color: '#42175a', margin: '10px 0'}}>
                        <Paper>
                            <div className='paper-padding'>
                                <div style={{
                                    margin: '15px 0',
                                    height: '150px',
                                    backgroundImage: `url(${each.img})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: '50% 50%'
                                }}/>
                                <a href={each.path} target='_blank'>
                                    <small>{each.email}</small>
                                </a>
                                <a href={each.path} target='_blank'>
                                <div>{each.name}</div>
                                </a>
                            </div>
                        </Paper>
                    </div>
                )}
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/StudentApp/Share.js